import { render, staticRenderFns } from "./AdminOnboarding.vue?vue&type=template&id=6a091a26&scoped=true&"
import script from "./AdminOnboarding.vue?vue&type=script&lang=js&"
export * from "./AdminOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AdminOnboarding.vue?vue&type=style&index=0&id=6a091a26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a091a26",
  null
  
)

export default component.exports